import { IOption } from '@vtbhome/juicyfront/types';

export const DISK_OPTIONS: IOption[] = [
    {
        label: 'Публичный',
        value: 'public_s3',
    },
    {
        label: 'Скрытый',
        value: 'private_s3',
    },
];

export const DEFAULT_DISK_OPTION: IOption[] = [DISK_OPTIONS[0]];
